import { render, staticRenderFns } from "./ECharts.vue?vue&type=template&id=36c2f65c"
import script from "./ECharts.vue?vue&type=script&lang=js"
export * from "./ECharts.vue?vue&type=script&lang=js"
import style0 from "./ECharts.vue?vue&type=style&index=0&id=36c2f65c&prod&lang=css"


/* normalize component */
import normalizer from "!../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports